<template>
	<div class="schemePage">
		<div class="schemePage-banner">
			<img :src="info.banner.img" width="100%" />
			<div class="schemePage-banner-desc">
				<p class="schemePage-banner-desc-title" v-html="info.banner.title"></p>
				<p class="schemePage-banner-desc-subtitle" v-html="info.banner.subtitle"></p>
			</div>
		</div>
		<div class="schemePage-container">
			<div class="schemePage-container-title">服务流程</div>
			<div class="schemePage-container-progress">
				<div class="schemePage-container-progress-item">
					<img src="/static/images/scheme/progress_1.jpg" width="100%" />
					选择险种
				</div>
				<i class="schemePage-container-progress-icon"></i>
				<div class="schemePage-container-progress-item">
					<img src="/static/images/scheme/progress_2.jpg" width="100%" />
					完善信息
				</div>
				<i class="schemePage-container-progress-icon"></i>
				<div class="schemePage-container-progress-item">
					<img src="/static/images/scheme/progress_3.jpg" width="100%" />
					评估报价
				</div>
				<i class="schemePage-container-progress-icon"></i>
				<div class="schemePage-container-progress-item">
					<img src="/static/images/scheme/progress_4.jpg" width="100%" />
					在线支付
				</div>
				<i class="schemePage-container-progress-icon"></i>
				<div class="schemePage-container-progress-item">
					<img src="/static/images/scheme/progress_5.jpg" width="100%" />
					出具保单
				</div>
			</div>
		</div>
		<div class="schemePage-container">
			<div class="schemePage-container-title">产品定制</div>
			<div class="schemePage-container-product">
				<div class="schemePage-container-product-item" 
					v-for="(item, index) in info.product" 
					:key="index" 
					@click="toDetail(products[item].url)"
					:class="{pointer:products[item].url}"
				>
					<img :src="products[item].img" width="100%"/>
					<div class="schemePage-container-product-item-content">
						<p class="schemePage-container-product-item-name">{{products[item].name}}</p>
						<p class="schemePage-container-product-item-desc" :class="[products[item].class]">{{products[item].desc}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="schemePage-container">
			<img src="/static/images/scheme/contact.jpg" width="100%" />
			<div class="schemePage-container-contact">
				<div class="schemePage-container-contact-title">企业定制保险咨询</div>
				<div class="schemePage-container-contact-subtitle">专业团队 · 方案定制 · 优化成本 · 理赔服务</div>
				<div class="schemePage-container-contact-phone"><b>0532-88931681</b>电话咨询</div>
			</div>
		</div>
		<div class="schemePage-container">
			<div class="schemePage-container-title">案例分析</div>
			<div class="schemePage-container-case">
				<img src="/static/images/scheme/case.jpg" width="100%" />
				<div class="schemePage-container-case-swiper">
					<Carousel v-model="caseValue" loop arrow="always" dots="none">
						<CarouselItem v-for="(item, index) in info.case" :key="index">
							<div class="schemePage-container-case-name">{{caseList[item].name}}</div>
							<div class="schemePage-container-case-desc" v-html="caseList[item].desc"></div>
						</CarouselItem>
					</Carousel>
				</div>
			</div>
		</div>
		<div class="schemePage-container">
			<div class="schemePage-container-title">常见问题</div>
			<div class="schemePage-container-question">
				<div class="schemePage-container-question-item">
					<img src="/static/images/scheme/icon_question_1.jpg" />
					<div class="schemePage-container-question-item-content">
						<span class="schemePage-container-question-item-question">如何获取发票？</span>
						<span class="schemePage-container-question-item-answer">
							发票在投保次月统一给到客户：<br>
							开普票的客户电子发票发送到客户预留邮箱；<br>
							开专票的客户纸质发票寄送到客户预留地址。
						</span>
					</div>
				</div>
				<div class="schemePage-container-question-item">
					<img src="/static/images/scheme/icon_question_2.jpg" />
					<div class="schemePage-container-question-item-content">
						<span class="schemePage-container-question-item-question">出单时间是多久？</span>
						<span class="schemePage-container-question-item-answer">
							自投保当天起算，五个工作日内出具保单。
						</span>
					</div>
				</div>
				<div class="schemePage-container-question-item">
					<img src="/static/images/scheme/icon_question_3.jpg" />
					<div class="schemePage-container-question-item-content">
						<span class="schemePage-container-question-item-question">有出险如何理赔，理赔周期多久？</span>
						<span class="schemePage-container-question-item-answer">
							1、拨打保险公司报案电话报案。<br>
							2、按照要求提供相关理赔材料。<br>
							3、保险公司将赔款汇入客户账户。
						</span>
					</div>
				</div>
				<div class="schemePage-container-question-item">
					<img src="/static/images/scheme/icon_question_4.jpg" />
					<div class="schemePage-container-question-item-content">
						<span class="schemePage-container-question-item-question">如果我需要咨询、协助理赔等服务，联系谁呢？</span>
						<span class="schemePage-container-question-item-answer">
							有任何困难可以拨打青岛海尔保险代理全国统一服务热线：0532-88931681。
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {products,caseList} from './dictionary'
export default {
	props:['info'],
	data(){
		return {
			products,
			caseList,
			caseValue:0
		}
	},
	methods:{
		toDetail(url){
			if(url){
				location.href=url
			}
		}
	}
}
</script>
<style scoped lang="less">
.schemePage{
	color: #333;
	&-banner{
		position: relative;
		&-desc{
			position: absolute;
			top: 18.75%;
			left: 0;
			width: 100%;
			text-align: center;
			font-size: 0;
			color: #fff;
			&::before{
				content: '';
				width: 60px;
				height: 5px;
				background: #fff;
				display: inline-block;
			}
			&-title{
				font-size: 65px;
				margin-top: 40px;
				line-height: 1;
			}
			&-subtitle{
				font-size: 22px;
				margin-top: 30px;
			}
		}
	}
	&-container{
		width: 1200px;
		background: #fff;
		margin: 75px auto 0;
		display: block;
		position: relative;
		&-title{
			text-align: center;
			font-size: 40px;
			margin-bottom: 54px;
			&::before,&::after{
				content: '';
				width: 37px;
				height: 24px;
				display: inline-block;
				background: url(/static/images/scheme/icon_title.png);
				margin: 0 16px;
			}
		}
		&-progress{
			text-align: center;
			&-item{
				width: 105px;
				font-size: 20px;
				color: #666;
				text-align: center;
				display: inline-block;
				vertical-align: middle;
				margin: 0 54px;
				line-height: 1;
				img{
					margin-bottom: 16px;
				}
			}
			&-icon{
				display: inline-block;
				vertical-align: super;
				width: 20px;
				height: 33px;
				background: url(/static/images/scheme/icon_right.jpg);
			}
		}
		&-product{
			width: 1236px;
			margin-left: -18px;
			&::after{
				content:'';
				display: block;
				clear: both;
			}
			&-item{
				width: 375px;
				margin: 0 18px 30px;
				box-shadow: 0 0 10px #ddd;
				float: left;
				&.pointer{
					cursor: pointer;
				}
				&-content{
					padding: 24px;
					height: 200px;
				}
				&-name{
					font-size: 24px;
					line-height: 1;
					margin-bottom: 16px;
				}
				&-desc{
					font-size: 18px;
					color: #666;
					&.fz16{
						font-size: 16px;
						line-height: 1.3;
					}
				}
			}
		}
		&-contact{
			left: 0;
			top: 72px;
			color: #fff;
			line-height: 1;
			position: absolute;
			text-align: center;
			width: 100%;
			&-title{
				font-size: 48px;
			}
			&-subtitle{
				font-size: 20px;
				margin-top: 20px;
			}
			&-phone{
				font-size: 24px;
				margin-top: 40px;
			}
		}
		&-case{
			position: relative;
			&-swiper{
				position: absolute;
				width: 660px;
				height: 100%;
				top: 0;
				right: 0;
			}
			&-name{
				color: #fff;
				font-size: 30px;
				margin-top: 52px;
				margin-bottom: 28px;
				line-height: 1;
				padding: 0 80px;
			}
			&-desc{
				color: #b2e0ff;
				font-size: 18px;
				padding: 0 80px;
			}
		}
		&-question{
			font-size: 0;
			&::after{
				content:'';
				display: block;
				clear: both;
			}
			&-item{
				float: left;
				padding-left: 48px;
				width: 50%;
				height: 160px;
				img{
					float: left;
				}
				&-content{
					margin-left: 100px;
					width: 360px;
				}
				&-question{
					font-size: 22px;
					display: block;
					margin-bottom: 10px;
					line-height: 1.2;
				}
				&-answer{
					font-size: 16px;
					color: #666;
				}
			}
		}
	}
}
</style>
<style lang="less">
.schemePage{
	.ivu-carousel{
		height: 100%;
		.ivu-carousel-arrow{
			&.right{
				text-align: center;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/scheme/components/common/Page.vue